/* src/components/Toolbar/components/StrokeWidth.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	assign,
	create_component,
	destroy_component,
	get_spread_object,
	get_spread_update,
	init,
	mount_component,
	noop,
	safe_not_equal,
	subscribe,
	transition_in,
	transition_out
} from "svelte/internal";

import Slider from "./Slider.svelte";

function create_fragment(ctx) {
	let slider;
	let current;

	const slider_spread_levels = [
		{ class: "fastboard-toolbar-slider" },
		/*props*/ ctx[0],
		{ min: 1 },
		{ max: 32 }
	];

	let slider_props = {};

	for (let i = 0; i < slider_spread_levels.length; i += 1) {
		slider_props = assign(slider_props, slider_spread_levels[i]);
	}

	slider = new Slider({ props: slider_props });
	slider.$on("change", /*set_stroke_width*/ ctx[2]);

	return {
		c() {
			create_component(slider.$$.fragment);
		},
		m(target, anchor) {
			mount_component(slider, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const slider_changes = (dirty & /*props*/ 1)
			? get_spread_update(slider_spread_levels, [
					slider_spread_levels[0],
					get_spread_object(/*props*/ ctx[0]),
					slider_spread_levels[2],
					slider_spread_levels[3]
				])
			: {};

			slider.$set(slider_changes);
		},
		i(local) {
			if (current) return;
			transition_in(slider.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(slider.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(slider, detaching);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let memberState;
	let value;
	let props;

	let $memberState,
		$$unsubscribe_memberState = noop,
		$$subscribe_memberState = () => ($$unsubscribe_memberState(), $$unsubscribe_memberState = subscribe(memberState, $$value => $$invalidate(7, $memberState = $$value)), memberState);

	$$self.$$.on_destroy.push(() => $$unsubscribe_memberState());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { disabled = false } = $$props;

	function set_stroke_width({ detail: value2 }) {
		app?.setStrokeWidth(value2);
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(3, app = $$props.app);
		if ('theme' in $$props) $$invalidate(4, theme = $$props.theme);
		if ('disabled' in $$props) $$invalidate(5, disabled = $$props.disabled);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*app*/ 8) {
			$: $$subscribe_memberState($$invalidate(1, memberState = app?.memberState));
		}

		if ($$self.$$.dirty & /*$memberState*/ 128) {
			$: $$invalidate(6, value = $memberState?.strokeWidth ?? 1);
		}

		if ($$self.$$.dirty & /*value, theme, disabled*/ 112) {
			$: $$invalidate(0, props = { value, theme, disabled });
		}
	};

	return [
		props,
		memberState,
		set_stroke_width,
		app,
		theme,
		disabled,
		value,
		$memberState
	];
}

class StrokeWidth extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { app: 3, theme: 4, disabled: 5 });
	}
}

export default StrokeWidth;